import { JobListItemSkeleton } from '@/components/features/JobList/JobListItemSkeleton';

export function JobListLoadingState() {
  return (
    <div className="flex flex-col gap-4 divide-y-thin divide-neutral-auxiliary">
      {Array.from({ length: 5 }).map((_, index) => (
        <JobListItemSkeleton key={index} />
      ))}
    </div>
  );
}
